import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=59df5dde&scoped=true"
import script from "./BankForm.vue?vue&type=script&lang=js"
export * from "./BankForm.vue?vue&type=script&lang=js"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=59df5dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59df5dde",
  null
  
)

export default component.exports